import React from 'react';
import {BaseIconProps} from '../../types';

export const BaseFlash: React.FC<BaseIconProps> = ({color, size}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.3695 1.34737C15.6629 1.51346 15.8094 1.85487 15.7276 2.18192L13.9606 9.25002H21C21.3033 9.25002 21.5768 9.43275 21.6929 9.71301C21.809 9.99326 21.7448 10.3158 21.5303 10.5303L9.53032 22.5303C9.29195 22.7687 8.92382 22.8188 8.63047 22.6527C8.33711 22.4866 8.19062 22.1452 8.27238 21.8181L10.0394 14.75H2.99999C2.69664 14.75 2.42317 14.5673 2.30708 14.287C2.191 14.0068 2.25516 13.6842 2.46966 13.4697L14.4697 1.46969C14.708 1.23131 15.0762 1.18127 15.3695 1.34737ZM4.81065 13.25H11C11.2309 13.25 11.449 13.3564 11.5911 13.5385C11.7333 13.7205 11.7836 13.9579 11.7276 14.1819L10.3843 19.555L19.1893 10.75H13C12.769 10.75 12.551 10.6436 12.4088 10.4616C12.2667 10.2795 12.2164 10.0422 12.2724 9.81812L13.6157 4.44501L4.81065 13.25Z"
        fill={color}
      />
    </svg>
  );
};
